<!-- eslint-disable -->
<template lang="pug">
    cs-button(
        v-if="uncompletedExercise"
        color="blue"
        @click=`$router.push({\
            name: getRouteName(uncompletedExercise),\
            params: {\
                exerciseId: uncompletedExercise.id,\
                homeworkId: homeworkId,\
                type: getRouteGameType(uncompletedExercise)\
                }
            })`
    )
        | {{ $i18n.t('common.common_navigation_goToNextGame') }}
    cs-button(
        v-else
        color="blue"
        @click="$router.push({name: 'dashboard'})"
    )
        | {{ $i18n.t('common.common_navigation_finishHomework') }}
</template>

<script>
    /*eslint-disable*/
    import HomeworkApi from '../../api/homework/homework';

    export default {
        props: [
            'exerciseId',
            'homeworkId'
        ],
        data () {
            return {
                currentGameName: '',
                uncompletedExercise: null,
            }
        },
        mounted() {
            this.fetchData();
        },
        methods: {
            fetchData() {
                HomeworkApi.show(this.homeworkId).then(response => {
                    this.currentGameName = response.homework.exercises.find(exercise =>
                            exercise.id === this.exerciseId
                    ).slug;
                    this.uncompletedExercise = response.homework.exercises.find(exercise =>
                            !exercise.isCompleted && exercise.id !== this.exerciseId
                    );
                })
                .catch(err => {
                    if (err && err.data && err.data.message) {
                        this.$toasted.error(err.data.message);
                    } else if (this.$i18n) {
                        this.$toasted.error(this.$i18n.t('errors.unable_to_load_next_exercise'));
                    }
                })
            },
            getRouteGameType (exercise) {
                if (exercise.parameters.default.withTime) {
                    return exercise.slug + 'WithTime';
                }
                return exercise.slug;
            },
            getRouteName (exercise) {
                return 'browse:game'
            }
        }
    }
</script>
